import React, { useState, useRef } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";
import "../cities.css";
import { Prefix } from "../../../services/prefix";
import Loading from "../../loader/loading";
import Swal from "sweetalert2";
import api from "../../../services/api";
import { uf } from "../../data/uf";
import Fontawesome from "../../fontawesome/fontawesome";
import { mutate as GlobalMutate } from "swr";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Schema from "./schema";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { useStyles } from "../../buttons/AddButtonStyle";
import { ModalContainer } from "../../../style/stylesModals"; 
import { CustomButton, TextButton } from "../../../style/stylesButton";

const IndexAddCity = (props) => {
  const [loader, setLoader] = useState();
  const [show, setShow] = useState(false);
  const [initialState, setInitialState] = useState({
    name: "",
    uf: "",
  });
  const [registerData, setRegisterData] = useState(initialState);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function HandleRegister(values) {
    setLoader(<Loading />);
    api
      .post(Prefix.replace(/[\\"]/g, "") + "/cities", values)
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Uow!",
          text: response.data.message,
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Fechar",
          cancelButtonText: "Novo Cadastro",
          allowOutsideClick: false,
          focusCancel: true,
        }).then((result) => {
          if (!result.isConfirmed) {
            setShow(true);
          }
        });
        setLoader();
        setShow(false);
        GlobalMutate(
          Prefix.replace(/[\\"]/g, "") +
            "/cities?per_page=" +
            props.perPage +
            "&page=" +
            props.pageExact +
            "&search=" +
            "&order_by=" +
            props.orderBy +
            "&order=" +
            props.order
        );
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.response.data.message,
          confirmButtonText: "Tentar novamente",
        });
        setLoader();
      });
  }

  const classes = useStyles();

  return (
    <>
      <Fab className={classes.fab} onClick={handleShow}>
        <AddIcon className={classes.icon} />
      </Fab>
      <ModalContainer
        show={show}
        size={props.modalSize}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
      >
        <Modal.Header closeButton>
          <Modal.Title><h3>{props.titleLabel}</h3></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik //--> Configuração do Formik
            initialValues={initialState}
            validationSchema={Schema}
            onSubmit={HandleRegister}
            enableReinitialize
          >
            {(
              { values } //--> Captação de valores
            ) => (
              <Form>
                <Row>
                  {loader}
                  <Col>
                    <div className="formStep">
                      <label class="important">Cidade</label>
                      <Field
                        type="text"
                        placeholder="Digite uma cidade"
                        name="name"
                      />
                      <ErrorMessage
                        name="name"
                        component="span"
                        className="errorMessages"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="formStep">
                      <label>Estado</label>
                      <Field as="select" name="uf">
                        <option selected>Selecione...</option>
                        {uf.map((estado) => (
                          <option value={estado.label}>{estado.label}</option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="uf"
                        component="span"
                        className="errorMessages"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="d-flex justify-content-center">
                    <CustomButton type="submit">
                    <TextButton >Cadastrar</TextButton>  
                    </CustomButton>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </ModalContainer>
    </>
  );
};
export default IndexAddCity;
